import { useCallback, useRef } from 'react';
import scrollIntoView from 'scroll-into-view-if-needed';

export const useScrollIntoView = <T extends HTMLElement>() => {
  const first = useRef(true);
  return useCallback((element: T | null) => {
    if (element) {
      const scrollPosition = first.current ? 'center' : 'nearest';
      // scrollIntoView must be called at the end of the frame
      //  or any transition by CSSTransition will be skipped
      requestAnimationFrame(() => {
        scrollIntoView(element, {
          scrollMode: 'if-needed',
          block: scrollPosition,
          inline: scrollPosition,
          skipOverflowHiddenElements: true,
        });
      });
      first.current = false;
    }
  }, []);
};
